"use client";

import { PricingSection } from "@/components/paywall/PricingSection";
import { Suspense } from "react";

function PricingSkeleton() {
  return (
    <div className="bg-[#0F0F14] py-16 md:py-24">
      <div className="max-w-6xl mx-auto px-4">
        <div className="text-center mb-12">
          <div className="mx-auto mb-4 h-10 w-64 rounded-lg bg-gray-700/50 motion-safe:animate-pulse" />
          <div className="mx-auto h-6 w-96 max-w-full rounded-lg bg-gray-700/50 motion-safe:animate-pulse" />
        </div>
        <div className="grid md:grid-cols-3 gap-6 md:gap-8">
          {[1, 2, 3].map((i) => (
            <div
              key={i}
              className="h-80 rounded-2xl bg-gray-800/50 p-6 motion-safe:animate-pulse"
            />
          ))}
        </div>
      </div>
    </div>
  );
}

export function LandingPricing() {
  return (
    <section id="pricing" className="bg-[#0F0F14]">
      <Suspense fallback={<PricingSkeleton />}>
        <PricingSection
          analyticsSource="landing_pricing"
          showHeader={true}
          headerTitle="Keep practicing after your free demo"
          headerSubtitle="Every paid plan includes unlimited conversations, 70+ languages, premium voice selection, and access to past sessions."
          redirectOnNoAuth="/auth?redirect=/landing"
          requireAuthUpfront={false}
          pricingCardVariant="landing"
        />
      </Suspense>
    </section>
  );
}
